<template>
  <div>
    <navbar>
      <template #before>
        <router-link to="/admin/users" class="btn btn-sm btn-outline-light">
          Back
        </router-link>
      </template>
      <template #title>
        <span class="text-light">Admin » Add User</span>
      </template>
    </navbar>
    <container>
      <hr class="border-top" />
      <form @submit.prevent="submit" method="post">
        <div class="row mb-3">
          <div class="col-12 col-md-4">
            <h3 class="fw-light">User Information</h3>
          </div>
          <div class="col-12 col-md-8">
            <div class="shadow-sm px-3 pt-3 card">
              <div v-if="error" class="alert alert-danger mb-3">
                {{ error }}
              </div>
              <div class="mb-3">
                <label for="userName">Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="user.name"
                  id="userName"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="userEmail">Email</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="user.email"
                  id="userEmail"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="userPassword">Password</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="user.password"
                  id="userPassword"
                  required
                  minlength="6"
                />
              </div>
              <div class="mb-3">
                <label for="userConfirmPassword">Confirm Password</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="confirmPassword"
                  id="userConfirmPassword"
                  required
                  minlength="6"
                />
                <div v-if="passwordMismatch" class="text-danger mt-1">
                  Passwords do not match
                </div>
              </div>
              <div class="form-check mb-3">
                <input
                  type="checkbox"
                  v-model="user.is_admin"
                  class="form-check-input"
                  id="userIsAdmin"
                />
                <label class="form-check-label" for="userIsAdmin">
                  Admin User
                </label>
              </div>
            </div>
          </div>
        </div>
        <hr class="border-top" />

        <!-- Action Tray -->
        <div class="mb-3 text-end">
          <button 
            class="btn btn-primary" 
            type="submit" 
            :disabled="loading || passwordMismatch"
          >
            <span v-if="loading">Creating...</span>
            <span v-else>Create User</span>
          </button>
        </div>
      </form>
    </container>
  </div>
</template>

<script>
export default {
  name: "AdminUsersCreate",
  data: () => ({
    user: {
      name: '',
      email: '',
      password: '',
      is_admin: false
    },
    confirmPassword: '',
    loading: false,
    error: null
  }),
  computed: {
    passwordMismatch() {
      return this.user.password && this.confirmPassword && this.user.password !== this.confirmPassword;
    }
  },
  methods: {
    async submit() {
      if (this.passwordMismatch) {
        return;
      }

      this.loading = true;
      this.error = null;

      try {
        const { data } = await this.axios.post('/api/users/admin-add.json', this.user);
        
        if (data.error) {
          this.error = data.error;
          if (data.errors) {
            this.error += ': ' + JSON.stringify(data.errors);
          }
        } else {
          this.$router.push('/admin/users');
        }
      } catch (error) {
        this.error = 'Failed to create user: ' + (error.response?.data?.error || error.message);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
